// Brand assets
export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_item-share-hub-3/artifacts/u9g6xizz_52D7766C-7A46-4385-8982-BA0BB3B86745.png";

export const BRAND = {
    name: "Lendly",
    tagline: "Borrow from your block. Lend to your neighbors.",
    description:
        "A friendlier way to borrow the things you need — and lend the things you don't use every day. Lendly connects neighbors, one item at a time.",
};
